import './slots.scss'
import React from 'react'
import classnames from 'classnames'
import Bluebird from 'bluebird'
import { times, every, clone } from 'lodash-es'
import {
    FaChevronCircleUp,
    FaChevronCircleDown,
    FaChevronCircleLeft,
    FaChevronCircleRight,
    FaTimesCircle,
    FaCheckCircle
} from 'react-icons/fa'

const { coroutine, delay } = Bluebird

const icons = [FaChevronCircleUp, FaChevronCircleDown, FaChevronCircleLeft, FaChevronCircleRight]
const startingPositions = [0, 0, 0]

export default class Slots extends React.Component {
    constructor() {
        super()
        this.hasAnimated = false
        this.spinnerRollIcons = times(3, (rollIndex) =>
            times(30, (i) => icons[(i + rollIndex) % icons.length])
        )
        this.state = { rollPositions: startingPositions }
    }

    startAnimation() {
        if (this.hasAnimated) {
            return
        }

        this.hasAnimated = true

        this.spin()
    }

    spin() {
        const self = this
        const direction = every(this.state.rollPositions, (pos) => pos === 0) ? 'down' : 'up'

        coroutine(function* () {
            for (let i = 0; i < 3; i++) {
                yield delay(250)
                const rollPositions = clone(self.state.rollPositions)
                rollPositions[i] = direction === 'down' ? 20 * (i + 1) * 16 : 0
                self.setState({ rollPositions })
            }
        })()

        coroutine(function* () {
            self.setState({ handlePull: true })
            yield delay(500)
            self.setState({ handlePull: false })
        })()
    }

    renderSpinner(spinnerIndex) {
        const renderedIcons = this.spinnerRollIcons[spinnerIndex].map((Icon, i) => {
            let IconComponent = Icon
            let className = 'slot-icon'

            if (i === 1) {
                IconComponent = FaTimesCircle
                className = 'slot-icon icon-times'
            }

            if (spinnerIndex === 0 && i === 9) {
                IconComponent = FaCheckCircle
                className = 'slot-icon icon-check'
            }

            if (spinnerIndex === 1 && i === 17) {
                IconComponent = FaCheckCircle
                className = 'slot-icon icon-check'
            }

            if (spinnerIndex === 2 && i === 25) {
                IconComponent = FaCheckCircle
                className = 'slot-icon icon-check'
            }

            return <IconComponent key={i} className={className} />
        })

        return (
            <div className="spinner" key={spinnerIndex}>
                <div
                    className="roll"
                    style={{ top: `-${this.state.rollPositions[spinnerIndex]}px` }}
                >
                    {renderedIcons}
                </div>
                <div className="gradient-mask top" />
                <div className="gradient-mask bottom" />
            </div>
        )
    }

    render() {
        const spinner = times(3, (i) => this.renderSpinner(i))

        return (
            <div className="slots">
                <div className="face">
                    <div
                        className={classnames('handle', { pulled: this.state.handlePull })}
                        onClick={() => this.spin()}
                    >
                        <div className="nob" />
                        <div className="stick" />
                        <div className="base" />
                    </div>
                    <div className="inner">{spinner}</div>
                </div>
            </div>
        )
    }
}
